// Cadastro de Cidades (DA-878). O campo Cidade do cliente escolhe daqui; cada cidade nasce da lista
// oficial do IBGE (nome sem acento + UF + codigo). Qualquer usuario cadastra. Sem editar nem
// remover: o nome vem do IBGE, e uma cidade em uso por cliente nao pode sumir.
import { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
import { api } from '../../lib/api';
import { useToast } from '../../components/Toast';
import { useStickyHeader } from '../../lib/useStickyHeader';
import { ModalNovaCidade, type Cidade } from '../../components/cidades/ModalNovaCidade';
import { contar } from '@fiodecobre/shared';

function semAcento(s: string): string {
  return s.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

export function Cidades() {
  const toast = useToast();
  const [itens, setItens] = useState<Cidade[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [busca, setBusca] = useState('');
  const [nova, setNova] = useState(false);

  async function carregar() {
    setCarregando(true);
    try {
      setItens(await api.get<Cidade[]>('/api/cidades'));
    } catch (e: any) {
      toast.erro(e.message);
    } finally {
      setCarregando(false);
    }
  }
  useEffect(() => { void carregar(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  const termo = semAcento(busca).toUpperCase().trim();
  const filtrados = termo
    ? itens.filter((c) => c.nome.includes(termo) || c.uf.includes(termo) || c.codigo_ibge.includes(termo))
    : itens;

  const sticky = useStickyHeader();

  return (
    <div>
      <div ref={sticky.headerRef} style={sticky.headerStyle}>
        <div className="pagina-header">
          <h2 className="pagina-titulo">
            <MapPin size={20} style={{ display: 'inline', marginRight: 6, marginBottom: -3 }} /> Cidades
          </h2>
          <div className="pagina-acoes">
            <input type="search" placeholder="Buscar cidade, UF ou codigo..." className="busca" value={busca} onChange={(e) => setBusca(e.target.value)} />
            <span className="muted" style={{ fontSize: 13 }}>{contar(filtrados.length, 'cidade')}</span>
            <button type="button" className="btn-primario" onClick={() => setNova(true)}>+ Nova cidade</button>
          </div>
        </div>
      </div>

      {carregando ? <p className="muted">Carregando...</p> : filtrados.length === 0 ? <p className="muted">Nenhuma cidade{termo ? ' com esse filtro' : ''}.</p> : (
        <table className="tabela" style={sticky.tableStyle}>
          <thead><tr>
            <th style={sticky.thStyle}>Cidade</th>
            <th style={{ ...sticky.thStyle, width: 70 }}>UF</th>
            <th style={{ ...sticky.thStyle, width: 130 }}>Codigo IBGE</th>
            <th style={{ ...sticky.thStyle, width: 100, textAlign: 'right' }}>Clientes</th>
          </tr></thead>
          <tbody>
            {filtrados.map((c) => (
              <tr key={c.id}>
                <td>{c.nome}</td>
                <td>{c.uf}</td>
                <td>{c.codigo_ibge}</td>
                <td style={{ textAlign: 'right' }}>{c.clientes ?? 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {nova && (
        <ModalNovaCidade
          jaCadastradas={itens.map((c) => c.codigo_ibge)}
          onFechar={() => setNova(false)}
          onSalvo={(c) => {
            setNova(false);
            toast.sucesso(`${c.nome} / ${c.uf} cadastrada.`);
            void carregar();
          }}
        />
      )}
    </div>
  );
}
